import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import MainMenu from './components/MainMenu';
import CartPagem from './components/CartPagem';
import SignIn from './components/sign-in';




class Root extends Component {
    render() {
        return(
	                <div>
                        <Router>
                            <Switch>
                                <Route  path="/MainMenu" component={MainMenu} />
                                <Route  path="/CartPagem" component={CartPagem} />
                                <Route  path="/SignIn" component={SignIn} />
                                <Route  path="/" component={SignIn} />
                            </Switch>
                        </Router>
                        <div class="bl-menu">
                            <a class="btn menu-click r-close">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </a>
                            <ul>
                                <li>STARTERS</li>
                                <li>VEGETABLES DISHES</li>
                                <li>VEGANI DISHES</li>
                                <li>CHICKEN DISHES</li>
                                <li>TANDOORI DISHES</li>
                                <li>LAMB DISHES</li>
                                <li>LASTEN DISHES</li>
                                <li>DESERTS LIST</li>
                                <li>DARSHAN SPECIAL MENU</li>
                                <li>SEAFOOD DISHES</li>
                                <li>BEVERAGES</li>
                            </ul>
                            </div>

                            <div class="content">
                                <a class="btn menu-click o-menu">
                            <i class="fa-solid fa-user-chef"></i> Main Menu
                            </a>
                        
                        </div>
                        <div class="bl-menu2">
                            <a class="btn menu-click2 r-close">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </a>
                            <ul>
                                <li>MONDAY</li>
                                <li>TUESDAY</li>
                                <li>WEDNESDAY</li>
                                <li>THURSDAY</li>
                                <li>FRIDAY</li>
                                <li>SATURDAY</li>
                            </ul>
                            </div>

                            <div class="content2">
                                <a class="btn menu-click2 o-menu2">
                                <i class="fa-solid fa-fork-knife"></i> Lunch Menu
                                </a>                        
                            </div>
                            <div class="content3">
                                <a class="btn menu-click3 o-menu3">
                                <i class="fa-solid fa-arrow-right-to-bracket"></i> Login
                                </a>                        
                            </div>
	                </div>
        )
    }
}

export default Root;

ReactDOM.render(<Root />, document.getElementById('restadeal'));
